<template>
    <div class="h-100">
        <b-container fluid class="p-0">
            <b-row align-h="center">
                <b-col cols="12" md="10">
                    <b-link :to="{ name: 'settings-teams' }"
                        ><font-awesome-icon icon="arrow-left" />
                        {{ $t("Back") }}
                    </b-link>
                    <h1 class="mt-1">
                        {{ $t("mainmenu.settings") }} / {{ $t("settings.teams.Teams") }} /
                        {{ $t("settings.teams.edit.title") }}
                    </h1>

                    <hr />

                    <div v-if="isLoading" class="d-flex justify-content-center mb-3">
                        <b-spinner />
                    </div>

                    <validation-observer v-if="!isLoading && teamData" ref="validationRules" name="team" tag="form">
                        <app-team-info :team-data="teamData" />
                        <app-channels :channels="channels" :team-data="teamData" />
                        <app-users :users="users" :team-data="teamData" />

                        <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7">
                            <b-button
                                :disabled="isSaving"
                                variant="primary"
                                class="d-flex justify-content-center mb-1"
                                @click="create"
                            >
                                <b-spinner v-if="isSaving" class="mr-50" small></b-spinner>
                                {{ $t("settings.teams.edit.submit") }}
                            </b-button>
                        </b-form-group>
                    </validation-observer>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import AppChannels from "./components/channels";
import AppTeamInfo from "./components/teamInfo";
import AppUsers from "./components/users";
import axios from "@/libs/axios";
import router from "@/router";
import useTeams from "./useTeams";
import { BButton, BRow, BCol, BContainer, BLink, BFormGroup, BSpinner } from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import { ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";

export default {
    components: {
        BButton,
        BCol,
        BRow,
        BContainer,
        BLink,
        BFormGroup,
        BSpinner,
        AppTeamInfo,
        AppChannels,
        AppUsers,
        ValidationObserver,
    },
    setup() {
        const toast = useToast();
        const teamData = ref({
            name: "",
            email: "",
            sendNotificationOnNewConversation: "0",
            color: "#000000",
            channels: [],
            users: [],
        });
        const { channels, users, fetchChannels, fetchUsers } = useTeams();
        const isLoading = ref(true);
        const isSaving = ref(false);

        fetchChannels({
            fields: "id,name",
        });
        fetchUsers({
            fields: "name",
            s: {
                $and: [{ role: { $ne: "api" } }, { role: { $ne: "saysimple" } }, { active: { $eq: 1 } }],
            },
        });

        axios
            .get(`/teams/${router.currentRoute.params.id}`, {
                params: {
                    join: ["teamUsers", "channels"],
                },
            })
            .then((response) => {
                response.data.channels = response.data.channels.map((channel) => channel.id);
                response.data.users = response.data.teamUsers
                    .map((teamUser) => {
                        const user = users.value.find((user) => user.id === teamUser.userId);
                        return user
                            ? {
                                  id: user.id,
                                  name: user.name,
                              }
                            : undefined;
                    })
                    .filter((user) => user);
                teamData.value = response.data;
            })
            .catch(() => (teamData.value = undefined))
            .finally(() => (isLoading.value = false));

        return {
            channels,
            users,
            teamData,
            toast,
            isLoading,
            isSaving,
        };
    },
    methods: {
        create() {
            return new Promise((resolve, reject) => {
                this.$refs.validationRules.validate().then((success) => {
                    if (success) {
                        const teamId = router.currentRoute.params.id;
                        const channels = this.teamData.channels.map((id) => ({ id }));

                        const teamUsers = this.teamData.users.map((user) => ({
                            userId: user.id,
                        }));

                        this.isSaving = true;

                        axios
                            .put(`teams/${teamId}`, {
                                ...this.teamData,
                                channels,
                                teamUsers,
                            })
                            .then(async (result) => {
                                this.$router.push({ name: "settings-teams" }, () => {
                                    this.toast.success(i18n.t("settings.teams.editted.success.description"));
                                });
                                resolve(result.data);
                            })
                            .catch(() => {
                                this.toast.error(
                                    i18n.t("toast.update.error", {
                                        entity: this.teamData.name,
                                    })
                                );
                                reject();
                            })
                            .finally(() => (this.isSaving = false));
                        resolve();
                    } else {
                        reject();
                    }
                });
            });
        },
    },
};
</script>
